module.exports = __webpack_public_path__ + "static/navyknitcardi-c170b225794ff490b30814cea13e765a.jpeg";